import { Navigate, Route, Routes } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    OnboardingContextProvider,
    useOnboarding,
} from '../../store/onboarding-context';
import WelcomeStep from './WelcomeStep';
import WorkbookWizard from './WorkbookWizard';
import BusinessInfoStep from './BusinessInfoStep';
import UsersStep from './UsersStep';
import MriScannerStep from './MriScannerStep';
import PoliciesStep from './PoliciesStep';
import FacilityDetail from '../facilities/FacilityDetailPage';
import LoadingRing from '../ui-components/LoadingRing';

export default function Workbook() {
    return (
        <OnboardingContextProvider>
            <WorkbookRoutes />
        </OnboardingContextProvider>
    );
}

function WorkbookRoutes() {
    const { t } = useTranslation();
    const { department, loading, error } = useOnboarding();

    if (loading) {
        return (
            <div className="flex min-h-screen items-center justify-center bg-background">
                <LoadingRing size="large" />
            </div>
        );
    }

    if (error || !department) {
        return (
            <div className="flex min-h-screen items-center justify-center bg-background">
                <p className="text-sm text-muted-foreground">
                    {t('onboarding.loadError')}
                </p>
            </div>
        );
    }

    return (
        <Routes>
            <Route path="/welcome" element={<WelcomeStep />} />
            <Route path="/wizard" element={<WorkbookWizard />}>
                <Route
                    index
                    element={<Navigate to="business-info" replace />}
                />
                <Route path="business-info" element={<BusinessInfoStep />} />
                <Route path="users" element={<UsersStep />} />
                <Route path="scanners" element={<MriScannerStep />} />
                <Route path="policies" element={<PoliciesStep />} />
            </Route>
            <Route
                path="/facility"
                element={
                    <div className="min-h-screen bg-background">
                        <FacilityDetail viewer="siteAdmin" />
                    </div>
                }
            />
            <Route path="*" element={<OnboardingIndexRedirect />} />
        </Routes>
    );
}

function OnboardingIndexRedirect() {
    const { department } = useOnboarding();
    const target = department?.onboardingCompletedAt ? '/facility' : '/welcome';
    return <Navigate to={target} replace />;
}
